import React, { useState } from 'react';
import { MarkerF, InfoWindowF } from '@react-google-maps/api';
import { Box, ClickAwayListener, Breakpoint } from '@mui/material';
import { useRouter } from 'next/router';
import styles from './styles';
import { PropertyListCard } from '../PropertyListCard/index';

export interface RecommendedPropertiesMarkerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  property: Record<string, any>;
  baseUrl: string;
  breakpoint?: Breakpoint | number;
  handleMarkerClick?: (propertyId: string) => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function Card({
  property,
  handleClickAway
}: {
  property: Record<string, any>;
  handleClickAway: () => void;
}) {
  const router = useRouter();
  const { pathname } = router;
  const basePath = pathname.substring(
    pathname.indexOf('/') + 1,
    pathname.lastIndexOf('/')
  );

  if (!property?.propertyBlob?.assetInfo?.assets?.photos) {
    return null;
  }

  const card = property;

  return (
    <InfoWindowF
      position={
        {
          lat: property?.location?.lat || 0,
          lng: property?.location?.lon || 0
        } as google.maps.LatLng
      }
      zIndex={4}
      options={{
        pixelOffset: new window.google.maps.Size(0, -15)
      }}
    >
      <ClickAwayListener onClickAway={handleClickAway}>
        <Box sx={styles.recommendedMapCardWrapper}>
          <PropertyListCard
            property={card}
            basePath={basePath}
            isRecommendedProperty
            favorited={false}
            heartIconOnClick={() => null}
            handleLoginClick={() => null}
            isEagerImg={false}
            isMapCard
          />
        </Box>
      </ClickAwayListener>
    </InfoWindowF>
  );
}

export default function RecommendedPropertiesMarker({
  property,
  baseUrl,
  handleMarkerClick
}: RecommendedPropertiesMarkerProps) {
  const [isCardOpen, setIsCardOpen] = useState(false);

  const handleClick = () => {
    if (handleMarkerClick) {
      handleMarkerClick(property?.propertyId || '');

      return;
    }

    if (!isCardOpen) {
      setIsCardOpen(true);
    } else {
      setIsCardOpen(false);
    }
  };

  const handleClickAway = () => {
    if (isCardOpen) {
      setIsCardOpen(false);
    }
  };

  return (
    <>
      <MarkerF
        onClick={handleClick}
        icon={{
          url:
            property?.isRecentSold || property?.isRecentLet
              ? '/mapImages/recommendedPropertySoldLet.png'
              : '/mapImages/recommendedProperty.png',
          scaledSize: new window.google.maps.Size(12, 12)
        }}
        position={
          {
            lat: property?.location?.lat || 0,
            lng: property?.location?.lon || 0
          } as google.maps.LatLng
        }
        title="Recommended property marker"
      />
      {!isCardOpen ? null : (
        <Card
          baseUrl={baseUrl}
          handleClickAway={handleClickAway}
          property={property}
        />
      )}
    </>
  );
}
